import { useEffect, useRef, useState } from "react";
import { useGetReportsIndexQuery } from "../../../services/api/reportsApi";
import { ReportStatusEnum } from "../../../services/api/types/reports/enums/ReportStatusEnum";

interface Props {
  onReportsReady?: () => void;
}
export function useGetReports({ onReportsReady }: Props) {
  const [pollingInterval, setPollingInterval] = useState(0);
  const { data: reports, isLoading: areReportsLoading } =
    useGetReportsIndexQuery(undefined, {
      pollingInterval,
    });

  const REPORT_POLLING_INTERVAL_MS = 3000;

  const prevHasInProgressRef = useRef(false);

  useEffect(() => {
    const hasInProgress = reports?.some(
      (r) =>
        r.status === ReportStatusEnum.PENDING ||
        r.status === ReportStatusEnum.PROCESSING,
    );
    const newInterval = hasInProgress ? REPORT_POLLING_INTERVAL_MS : 0;
    setPollingInterval((currentInterval) =>
      currentInterval !== newInterval ? newInterval : currentInterval,
    );

    if (prevHasInProgressRef.current && !hasInProgress) {
      onReportsReady?.();
    }
    prevHasInProgressRef.current = hasInProgress ?? false;
  }, [reports]);

  return {
    reports,
    areReportsLoading,
  };
}
